export default {
  LANG: "pt-BR",
  HEADER_ITEM_TITLE_HOME: "Home",
  HEADER_ITEM_TITLE_ABOUT: "Sobre",
  HEADER_ITEM_TITLE_CASES: "Cases",
  HEADER_ITEM_TITLE_CONTACT: "Contato",
  HEADER_ITEM_TITLE_CV: "Acessar CV",

  BANNER_TITLE: "Wilton Junior",
  BANNER_SUB_TITLE: "Full Stack Developer",
  BANNER_SUB_PARAGRAPH_ONE: `Programador full-stack, apaixonado pelo desenvolvimento de software, graduado em <strong>Cientista da computação</strong>, pela <strong>Universidade Estatual do Rio Grande do Norte - UERN</strong>, atuando desde de 2016 em desenvolvimento 
  de sistemas web e mobile. </br> </br> Utilizando as mais diversar tecnologias da atualidade, com aplicabilidade na construção de aplicações hibridas, resposivas e cross browser. Atualmente atuando como líder de projeto.`,
  BANNER_BUTTON_PORTFOLIO: "Portfolio",
  BANNER_BUTTON_CONTACT: "Contato",

  ABOUT_DESCRIPTION: `Programador e desenvolvedor há mais de <strong>5 anos</strong> atuando diretamente no mercado.
  Tive início na carreira dentro da universidade, atuando em projetos de pesquisa ensino e extenção, 
  foi quando percebi o que realmente nasci para fazer: <strong>codar</strong>, adoro construir templates de zero, sem a 
  necessidade de utilizar qualquer framework css, quanto maior o desafio, melhor!
  </br> </br> 
  Meu primeiro emprego foi em uma <strong>multinacional</strong>, que me proporcionou experiências incríveis que me fizeram crescer ainda mais como profissional, 
  a partir daí começaram os projetos externos das mais diversas formas, websites, aplicativos, sistemas, que me fizeram adquirir um vasto
  conhecimento nas diversas linguagens de programação hoje utilizadas pelo mercado.
  </br> </br> 
  Contínuo investindo cada vez mais na minha carreira como desenvolvedor, estudando e passando um pouco da minha experiência para meus colegas da área, sempre em contato com a comunidade. Com esse intuito criamos uma plataforma para os desenvolvedores compartilharem suas experiências, que chamamos de <a href="https://share.dev.br/" >Dev Share</a> 
  tendo o objetivo de atingir o maior número de desenvolvedores com artigos das mais diversas áreas da tecnologia.`,
  ABOUT_CARD_TITLE_ONE: "Academia",
  ABOUT_CARD_DESCRIPTION_ONE:
    "Graduado em Ciência da computação pela Universidade Estado do Rio Grande do Norte - UERN.",
  ABOUT_CARD_TITLE_TWO: "Experiencia",
  ABOUT_CARD_DESCRIPTION_TWO:
    "Atuo desde 2016 com desenvolvimento front end, back end e mobile. Especialmente com a stack de java script, como Reactjs, Angular.io, Vuejs e Nodejs.",

  ABOUT_SECTION_SHADOW: "Sobre",
  ABOUT_SECTION_TITLE: "Sobre mim",
  ABOUT_SECTION_DESCRIPTION: "Conheça um pouco da minha historia.",

  ACESS_CASE: "Acessar Case",

  CONTACT_TITLE: "Contato",
  CONTACT_DESCRITPION:
    "Se você deseja entrar em contato, preencha o formulário abaixo. Entrarei em contato com você em breve.",
  CONTACT_INPUT_LABEL_NAME: "Name",
  CONTACT_INPUT_LABEL_EMAIL: "Email",
  CONTACT_INPUT_LABEL_MESSAGE: "Mensagem",
  CONTACT_FORM_SEND: "Enviar",
  CONTACT_INPUT_PLACEHOLDER_NAME: "Name",
  CONTACT_INPUT_PLACEHOLDER_EMAIL: "Email",
  CONTACT_INPUT_PLACEHOLDER_MESSAGE: "Mensagem",

  CONTACT_WHATSAPP: "Whatsapp",
  CONTACT_INSTAGRAM: "Instagram",
  CONTACT_EMAIL: "Email",
  CONTACT_LINKEDIN: "Linkedin",
  CONTACT_GIT: "Git Hub",

  FOOTER_TITLE: "©Copyright 2020 WiltonJunior. All Rights Reserved",

  CASE_TITLE: "Cases",
  CASE_SHODOW: "Portfolio",
  CASE_DESCRIPTION: "Navegue em meus trabalhos.",

  CASE_ONE_TITLE: "Mais Milhas",
  CASE_ONE_DESCRIPTION: "Uma plataforma para a compra e venda de milhas aéreas",
  CASE_ONE_ARTICLE_ONE_TITLE:
    "O MaisMilhas tem como objeto a compra e venda de milhas aéreas, a aplicação foi construida utilizando uma série de tecnologias dentre as quais, destaca-se o Nextjs por aumentar a performace desempenho da aplicação, o back-end foi construído utilizando Nodejs com mongoDB",

  CASE_TWO_TITLE: "Zabbix Report",
  CASE_TWO_DESCRIPTION: "Lady page para divulgação e apresentação da empresa",
  CASE_TWO_ARTICLE_ONE_TITLE:
    "Aplicação multiplataforma cross browser, responsável por divulgar e apresentar o produto. O front-end foi construído utilizando React e o back-end em Nodejs com sequelize",

  CASE_THREE_TITLE: "Easy Institute",
  CASE_THREE_DESCRIPTION: "Lady page para divulgação e apresentação da empresa",
  CASE_THREE_ARTICLE_ONE_TITLE:
    "Aplicação multiplataforma cross browser, responsável por divulgar e apresentar a escola e suas unidades, constituído por uma área administrativa para controle das filiais. O front-end foi construído utilizando Angular.io e o back-end em Nodejs com arangoDB",

  CASE_FOUR_TITLE: "Dev Share",
  CASE_FOUR_DESCRIPTION: "O Dev Share é uma plataforma com objetivo de compartilhar informações a respeito dastendências do mercado de tecnologia",
  CASE_FOUR_ARTICLE_ONE_TITLE: "A plataforma é constituida por um dashboard que gerencia os posts dos usuários que publicam as informações. A aplicação foi construída utilizando Nextjs na página pincipal e React na página de Admin. O back end foi feito utilizando Nodejs e MongoDB para armazenar os dados",
}
